<template>
  <div class="tags-performance-container">
    <h3 class="tags-performance-title">
      {{ title }}
    </h3>
    <p
      v-if="shouldShowDescription"
      class="tags-performance-description"
    >
      {{ description }}
    </p>
    <template v-if="shouldShowTagsPerformanceList">
      <div class="tags-performance-list-block">
        <ul class="tags-performance-list">
          <TagsPerformanceListItem
            v-for="(listItem, index) in tagsPerformanceList"
            :key="index"
            :item="listItem"
            :click-item-handler="clickItemHandler"
          />
        </ul>

        <a
          v-if="!isSignedIn"
          class="tags-performance-sign-up-hint"
          :href="maskCTALink"
        >
          <div class="tags-performance-sign-up-hint-button">
            點我查看完整內容
          </div>
        </a>
      </div>
    </template>
    <template v-else-if="shouldShowLoading">
      <CommonLoadingHint class="tags-performance-common-loading" />
    </template>
    <template v-else>
      <TagsPerformanceErrorHint />
    </template>
  </div>
</template>

<script>
import { CommonLoadingHint } from '@/modules/shared/components/CommonHint'

import TagsPerformanceErrorHint from './TagsPerformanceErrorHint.vue'
import TagsPerformanceListItem from './TagsPerformanceListItem.vue'

export default {
  name: 'ContainerTagsPerformance',
  components: {
    TagsPerformanceListItem,
    CommonLoadingHint,
    TagsPerformanceErrorHint,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    tagsPerformanceList: {
      type: Array,
      default: () => ([]),
      validator(list) {
        if (list.length === 0) return true
        return list.length > 0 && list.every((item) => (Object.keys(item).includes('name')
          && Object.keys(item).includes('diff_percentage')
          && Object.keys(item).includes('url')))
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hasLoadingError: {
      type: Boolean,
      default: false,
    },
    isSignedIn: {
      type: Boolean,
      required: true,
    },
    clickItemHandler: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    shouldShowDescription() {
      return this.description.length > 0
    },
    shouldShowTagsPerformanceList() {
      return this.tagsPerformanceList.length > 0 && !this.isLoading && !this.hasLoadingError
    },
    shouldShowLoading() {
      return this.isLoading && !this.hasLoadingError
    },
    maskCTALink() {
      return '/users/sign_up'
    },
  },
}
</script>

<style lang="scss" scoped>
.tags-performance-container {
  background-color: #fff;
  color: #434343;
  text-align: left;

  @media (min-width: 768px) {
    margin: 6px 0;
    padding-left: 15px;
    padding-right: 15px;
    border: 1px solid #dfdfdf;
    box-shadow: none;
    border-radius: 3px;
  }
}
.tags-performance-title {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: bold;

  @media (min-width: 768px) {
    padding-top: 15px;
    margin-bottom: 12px;
    font-size: 18px;
  }
}
.tags-performance-description {
  font-size: 0.875rem;
  line-height: 165%;

  @media (min-width: 768px) {
    font-size: 13px;
    line-height: 180%;
  }
}

.tags-performance-list {
  margin: 0;
  text-align: left;
  list-style: none;

  @media (min-width: 768px) {
    margin-top: 3px;
    padding-bottom: 3px;
  }
}
.tags-performance-common-loading {
  box-sizing: border-box;
  height: 315px;
  margin-top: 3px;
  padding: 4.5rem 0;
}

.tags-performance-list-block {
  position: relative;

  .tags-performance-sign-up-hint {
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    cursor: pointer;
    background-image: linear-gradient(to bottom, transparent, #fff 75%);

    .tags-performance-sign-up-hint-button {
      position: absolute;
      bottom: 1.5rem;
      text-align: center;
      color: #fff;
      font-size: 1rem;
      font-weight: bold;
      background-color: #0386f4;
      width: 100%;
      height: 44px;
      line-height: 44px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      cursor: pointer;

      @media (min-width: 768px) {
        font-size: 15px;
        bottom: 15px;
        border-radius: 6px;
      }
    }
  }
}
</style>
